"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputContainer = exports.InputPlaceholder = exports.RCCFields = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _templateObject, _templateObject2, _templateObject3;

var RCCFields = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  margin: 16px -2px 0;\n\n  label {\n    display: none;\n  }\n\n  & > div {\n    flex: 1;\n    margin: 0 2px;\n  }\n\n  input {\n    text-align: center;\n    padding: 0;\n  }\n\n  div[id^='input-aux'] {\n    padding-top: 0;\n    div[class$='Grid'] {\n      display: none;\n    }\n  }\n\n  @media (min-width: 640px) {\n    margin: 16px -4px 0;\n\n    & > div {\n      margin: 0 4px;\n    }\n  }\n"])));

exports.RCCFields = RCCFields;

var InputPlaceholder = _styled.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  height: 48px;\n  background: #ddd;\n"])));

exports.InputPlaceholder = InputPlaceholder;

var InputContainer = _styled.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: auto;\n"])));

exports.InputContainer = InputContainer;